export { default as MazeSnippet } from "./maze.component";
